import { render, staticRenderFns } from "./Gasto.vue?vue&type=template&id=1259dc92&"
import script from "./Gasto.vue?vue&type=script&lang=js&"
export * from "./Gasto.vue?vue&type=script&lang=js&"
import style0 from "./Gasto.vue?vue&type=style&index=0&id=1259dc92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports